import {useQuery} from "@apollo/client";
import {useState} from "react";

import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";
import {AccountUsersQueryResponse, GQL_ACCOUNTUSERS_QUERY} from "@/lib/queries/accounts.ts";
import {UsersTable} from "@/pages/accounts/list/UsersTable.tsx";

export const UsersList = () => {
  const [sortingColAndDirection, setSortingColAndDirection] = useState<Sorting>({
    column: "name",
    direction: SortingDirection.Asc,
  });
  const [subaccountID, setSubaccount] = useState<number | undefined>(undefined);
  const {data, loading, previousData} = useQuery<AccountUsersQueryResponse>(GQL_ACCOUNTUSERS_QUERY, {
    variables: {
      subaccount: subaccountID,
      sort:
        sortingColAndDirection.direction == SortingDirection.Asc
          ? sortingColAndDirection.column
          : `-${sortingColAndDirection.column}`,
    },
  });
  const renderData = loading ? previousData : data;
  if (!renderData) return null;
  return (
    <UsersTable
      users={renderData.accountUsers}
      accountAccounts={renderData.accountAccounts}
      sortColumn={sortingColAndDirection.column}
      sortDirection={sortingColAndDirection.direction}
      onSortingChange={setSortingColAndDirection}
      subaccountID={subaccountID}
      onSubaccountChange={setSubaccount}
    />
  );
};

export default UsersList;
